<div class="d-flex flex-column">
    <span class="mb-4">
        {{ "ISSUE_REPORT_CONTENT" | translate }}
    </span>
    <form [formGroup]="reportForm" class="d-flex flex-column">
        <div class="d-flex flex-column mb-4">
            <textarea
                formControlName="content"
                placeholder="{{'ISSUE_REPORT_PLACEHOLDER' | translate}}"
            ></textarea>
        </div>
            <button
                class="btn mx-auto"
                [disabled]="reportForm.invalid"
                (click)="sendIssueFeedback()"
            >
                Send
            </button>
    </form>
</div>
